module.exports = __webpack_public_path__ + "media/promo/panasonic/images/icons/i-6-41d5f851b90d51b2c3dff27556adf9c7.svg";